import expertise from './expertise.vue'
export default expertise